import { render, staticRenderFns } from "./Tab3.vue?vue&type=template&id=3ee2c7ce&scoped=true&"
import script from "./Tab3.vue?vue&type=script&lang=js&"
export * from "./Tab3.vue?vue&type=script&lang=js&"
import style0 from "./Tab3.vue?vue&type=style&index=0&id=3ee2c7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee2c7ce",
  null
  
)

export default component.exports